import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  circle: {
    marginRight: theme.spacing(2)
  }
}));

const Loader = ({ className, message }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)}>
      <CircularProgress className={classes.circle} color="primary" size={24} />
      <div>{message}</div>
    </div>
  );
};

Loader.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string
};

Loader.defaultProps = {
  className: '',
  message: ''
};

export default Loader;
